import { strCode } from "../consts";
import { selectMarkets } from "../state/selectors";
import { getState } from "../state/store";

const getMarketName = (marketCode) => {
  const markets = selectMarkets()(getState())?.reduce((accum, curr) => {
    return {
      ...accum,
      [curr.market]: curr.country
    };
  }, {});

  return markets ? markets[marketCode] : strCode.UNKNOWN;
};

const marketUtil = {
  getMarketName
};

export default marketUtil;
